import { render, staticRenderFns } from "./forgetpwd.vue?vue&type=template&id=651d4715&scoped=true"
import script from "./forgetpwd.vue?vue&type=script&lang=js"
export * from "./forgetpwd.vue?vue&type=script&lang=js"
import style0 from "./forgetpwd.vue?vue&type=style&index=0&id=651d4715&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d4715",
  null
  
)

export default component.exports